var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState, useSyncExternalStore } from 'react';
import { useEventSubmitSuccess } from '../../eventLifecycleChannel';
import { ComposerMode } from '../../types/index';
import { getRecentSavesVersion, msUntilSaveCooldownEnds, recordEventSave, subscribeToRecentSaves, } from '../../utils/recentEventSaves';
/**
 * The details panel's edit-then-move guard: true while `eventId` was saved
 * less than RECENT_SAVE_COOLDOWN_MS ago, during which "change room" is
 * disabled (a /move against a still-syncing PATCH copies stale data — see
 * recentEventSaves).
 *
 * Reads the store the composer's save path writes (the panel is usually
 * unmounted at submit time, so a channel subscription alone would miss the
 * save; localStorage also carries it across refreshes and tabs). The bridge
 * submit-success listener additionally records saves emitted while mounted;
 * its write bumps the store version, which re-runs the evaluation below.
 * A timer flips the state back once the cooldown lapses.
 */
export var useRecentSaveCooldown = function (eventId) {
    var _a = __read(useState(function () { return msUntilSaveCooldownEnds(eventId) > 0; }), 2), coolingDown = _a[0], setCoolingDown = _a[1];
    // Re-evaluate whenever the store changes — this tab's writes (any
    // bundle) or another tab's (via the 'storage' event).
    var savesVersion = useSyncExternalStore(subscribeToRecentSaves, getRecentSavesVersion);
    useEventSubmitSuccess(function (payload) {
        var _a;
        if (payload.composerMode !== ComposerMode.EDIT)
            return;
        recordEventSave((_a = payload.event) === null || _a === void 0 ? void 0 : _a.id, payload.originalEventId);
    });
    useEffect(function () {
        var remaining = msUntilSaveCooldownEnds(eventId);
        if (remaining > 0 !== coolingDown) {
            setCoolingDown(remaining > 0);
            return;
        }
        if (remaining > 0) {
            var timer_1 = setTimeout(function () { return setCoolingDown(false); }, remaining);
            return function () { return clearTimeout(timer_1); };
        }
    }, [eventId, coolingDown, savesVersion]);
    return coolingDown;
};
